"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _theme = require("../../theme");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var colors = {
  error: _theme.palette.error.main,
  primary: _theme.palette.primary.main
};

var Icon = function Icon(_ref) {
  var iconName = _ref.iconName,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "inherit" : _ref$color,
      _ref$iconStyle = _ref.iconStyle,
      iconStyle = _ref$iconStyle === void 0 ? "fas" : _ref$iconStyle,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      m = _ref.m,
      mx = _ref.mx,
      my = _ref.my,
      ml = _ref.ml,
      mr = _ref.mr,
      mt = _ref.mt,
      mb = _ref.mb,
      style = _ref.style;

  // Returns the value of the most specific token
  var getSpacingToken = function getSpacingToken(directionToken, axisToken) {
    if (directionToken || directionToken === 0) return directionToken;
    if (axisToken || axisToken === 0) return axisToken;
    return m || 0;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Icon, {
    className: "".concat(iconStyle, " fa-").concat(iconName),
    fontSize: size === "small" || size === "large" ? size : "medium",
    style: _objectSpread({
      color: colors[color] || color,
      marginBottom: _theme.spacing[getSpacingToken(mb, my)],
      marginLeft: _theme.spacing[getSpacingToken(ml, mx)],
      marginRight: _theme.spacing[getSpacingToken(mr, mx)],
      marginTop: _theme.spacing[getSpacingToken(mt, my)]
    }, style)
  });
};

var _default = Icon;
exports.default = _default;